import { COMPANY, NAV } from "@/lib/content";
import { EmailText } from "./EmailText";
import { LogoTile } from "./Logo";

export const Footer = () => (
  <footer className="bg-[#0F3D38] text-[#FBF8F1] pt-16 pb-10 border-t-4 border-[#CDA34F] no-print" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
      <p className="font-serif text-[16vw] lg:text-[11rem] leading-[0.8] tracking-tight text-[#FBF8F1]/90 select-none" aria-hidden>Elevion<span className="text-[#CDA34F]">.</span></p>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 flex items-start gap-4">
          <LogoTile />
          <div className="text-sm text-[#D6E0D9] space-y-0.5">
            <p className="text-lg font-bold text-[#FBF8F1]">{COMPANY.name}</p>
            <p>{COMPANY.street}</p><p>{COMPANY.cityLine}</p>
            <p className="pt-1"><a href={COMPANY.phoneHref} className="font-bold text-[#E2C372] hover:underline">{COMPANY.phoneDisplay}</a></p>
            <p><a href={`mailto:${COMPANY.email}`} className="underline hover:text-[#E2C372]" data-testid="footer-email-link"><EmailText /></a></p>
          </div>
        </div>
        <nav className="md:col-span-4 grid grid-cols-2 gap-2 text-sm" aria-label="Footer">
          {[...NAV, { href: "#apply-online", label: "Apply" }, { href: "#privacy-notice", label: "Privacy" }].map((n) => (
            <a key={n.href} href={n.href} className="text-[#D6E0D9] hover:text-[#E2C372] py-1">{n.label}</a>
          ))}
        </nav>
        <div className="md:col-span-3 space-y-2.5">
          <a href={COMPANY.phoneHref} className="btn-gold w-full justify-center">Call {COMPANY.phoneDisplay}</a>
          <a href={`mailto:${COMPANY.email}`} className="btn-cream w-full justify-center">Email Elevion</a>
          <a href="#apply-online" className="btn-outline-light w-full justify-center">Employment application</a>
        </div>
      </div>
      <div className="pt-6 border-t border-[#FBF8F1]/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#D6E0D9]">
        <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
        <div className="flex flex-wrap items-center gap-4">
          <a href="#privacy-notice" className="hover:underline">Privacy &amp; Security</a>
          <a href={`mailto:${COMPANY.email}`} className="hover:underline">{COMPANY.email}</a>
          <a href="/admin" className="hover:underline" data-testid="footer-admin-link">Staff login</a>
        </div>
      </div>
    </div>
  </footer>
);
